import { render } from "./CardSkeleton.vue?vue&type=template&id=72d51421&scoped=true"
import script from "./CardSkeleton.vue?vue&type=script&lang=js"
export * from "./CardSkeleton.vue?vue&type=script&lang=js"

import "./CardSkeleton.vue?vue&type=style&index=0&id=72d51421&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72d51421"]])

export default __exports__